import type { SVGProps } from "react";
// generated from Mail.svg — do not edit manually
// prettier-ignore
export default function Mail(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 2 7 V 20 H 22 V 7 M 2 7 V 4 H 22 V 7 M 2 7 L 12 14 L 22 7" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
